<template>
  <div>
    <table class="table table-strips">
      <thead>
        <tr>
          <th>ردیف</th>
          <th>از شماره</th>
          <th>تا شماره</th>
          <th>قیمت</th>
          <th>توضیحات</th>
          <th>حذف</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in chairsList" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.start }}</td>
          <td>{{ item.end }}</td>
          <td>{{ this.utils.monize(item.price) }}</td>
          <td>{{ item.description }}</td>
          <td>
            <button
              class="btn btn-sm btn-danger"
              :disabled="loading"
              @click="deleteChairs(item.id)"
            >
              <i class="fas fa-trash"></i>
              <span v-if="loading">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ArefApi from "../../../libs/api.js";
import utils from "../../../libs/utils.js";

export default {
  name: "AddChairs",
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  created: function () {
    this.utils = new utils();
    this.arefApi = new ArefApi(this);
    this.getProductChairs();
  },

  data() {
    return {
      chairsList: null,
      loading: false,
    };
  },
  methods: {
    getProductChairs() {
      this.arefApi
        .getProductChairs(this.productId, 1, true)
        .then((resp) => {
          this.chairsList = resp.data;
          console.log(resp);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    deleteChairs(id) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.loading = true;
            this.arefApi
              .deleteChairs(id)
              .then(() => {
                this.utils.showSuccess(this);
                this.getProductChairs();
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
  },
};
</script>